import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in a pill mode which is typically used for extending the available search fields.
 * Pills are typically styled in a more compact fashion.
 */
@Injectable()
export class FUIPillFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.PILL, "Pill");
    }
}
